var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lamp-notif-sized-container-for-mobile",
      style: { height: _vm.windowHeight + "px" }
    },
    [
      _c("div", { staticClass: "row ml-3 lamp-notif-container-mobile" }, [
        _c(
          "div",
          {
            staticClass: "nav sidebar-list flex-column col-10 col-sm-6 col-md-5"
          },
          [
            _vm._l(_vm.links, function(item) {
              return [
                item.isMainButton
                  ? [
                      _c(
                        "b-button",
                        {
                          staticClass: "sidebar-create-annonce-btn",
                          class: _vm.activeItem(item),
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.itemClicked(item)
                            }
                          }
                        },
                        [
                          _c("b-nav-item", { class: "sidebar-link-btn" }, [
                            _c("div", [_vm._v(_vm._s(item.title))])
                          ])
                        ],
                        1
                      )
                    ]
                  : !item.isLogout && _vm.activeItem(item)
                  ? [
                      _c(
                        "b-nav-item",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-mobile",
                              modifiers: { "sidebar-mobile": true }
                            }
                          ],
                          class:
                            "sidebar-link " +
                            _vm.activeItem(item) +
                            (item.isRed ? " sidebar-link-red" : "") +
                            " " +
                            item.customClass,
                          attrs: { disabled: "" }
                        },
                        [
                          _c("i", {
                            class:
                              item.icon +
                              " mr-3 ph-xl ph-bold " +
                              _vm.activeItem(item)
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: _vm.activeItem(item),
                              staticStyle: { "text-align": "left" }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        ]
                      )
                    ]
                  : [
                      _c(
                        "b-nav-item",
                        {
                          class:
                            "sidebar-link " +
                            (item.isRed ? " sidebar-link-red" : "") +
                            " " +
                            item.customClass,
                          on: {
                            click: function($event) {
                              item.isLogout
                                ? _vm.logout()
                                : _vm.itemClicked(item)
                            }
                          }
                        },
                        [
                          _c("i", {
                            class: item.icon + " mr-3 ph-xl ph-bold "
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(item.title))
                          ])
                        ]
                      )
                    ]
              ]
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2118f6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2118f6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/menus/SideMenu.vue
// module id = P658
// module chunks = 0